const MONTHS = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export function shortFormat(date) {
    if (date) {
        // Format as mm/dd/yyyy
        return date.toLocaleDateString("en-US");
    }
    return "";
}

export function postFormat(publishDate) {
    const date = new Date(publishDate);
    if (date) {
        // Format as mm/dd/yyyy at hr:min
        return `${shortFormat(date)} at ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`.toLowerCase();
    }
    return "";
}

export function eventFormat(publishDate) {
    const date = new Date(publishDate);
    if (date) {
        // Format as mm/dd/yyyy at hr:min
        return `${shortFormat(date)} at ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`.toLowerCase();
    }
    return "";
}

export function expandedFormat(date) {
    if (date) {
        // Format as month day, year at hr:min
        return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()} at ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).toLowerCase()}`;
    }
    return "";
}
